import Dom from './dom';
import DomNew from './dom-new';
import Dom3d from './dom3d';
import Roi from './roi';
import Roi3d from './roi3d';
import Image from './image';
import Background from './background';
import Device from './device';
import Line from './line';
import Line3D from './line3d';
import Path3D from './path3d';
import Path2D from './path2d';
import Line2D from './line2d';
import LineLoop from './line-loop';
import HEATMAP from './heat-map';
import HEATMAPCOMPLEX from './heat-map-complex';
import HEATMAPS from './heat-maps';
import GLTF from './gltf';
import Person from './person';
import Ellipse from './ellipse';
import Ellipse3d from './ellipse3d';
import Car2d from './car';
import Car3d from './car3d';
import Car3dS from './car3ds';
import Parking from './parking';
import Parking3d from './parking3d';
import Persons from './persons';
import Person2d from './person2d';
// | Fence;
export const ELementType = {
    IMAGE: 'image',
    ROI: 'roi',
    DOM: 'dom',
    DEVICE: 'device',
    LINE: 'line',
    LINE3D: 'line3d',
    PATH3D: 'path3d',
    PATH2D: 'path2d',
    LINE2D: 'line2d',
    LINELOOP: 'lineloop',
    HEATMAP: 'heatmap',
    HEATMAPCOMPLEX: 'heatmapcomplex',
    GLTF: 'gltf',
    Background: 'background',
    Dom3d: 'dom3d',
    HEATMAPS: 'heatmaps',
    DomNew: 'domnew',
    Person: 'person',
    Roi3d: 'roi3d',
    Ellipse: 'ellipse',
    Ellipse3d: 'ellipse3d',
    Car2D: 'car2d',
    Car3D: 'car3d',
    Car3DS: 'car3ds',
    Parking3d: 'parking3d',
    Parking: 'parking',
    Persons: 'persons',
    Person2d: 'person2d',
    Fence: 'fence'
};
const Objects = {
    [ELementType.DOM]: Dom,
    [ELementType.IMAGE]: Image,
    [ELementType.ROI]: Roi,
    [ELementType.DEVICE]: Device,
    [ELementType.LINE]: Line,
    [ELementType.LINE3D]: Line3D,
    [ELementType.PATH3D]: Path3D,
    [ELementType.PATH2D]: Path2D,
    [ELementType.LINE2D]: Line2D,
    [ELementType.LINELOOP]: LineLoop,
    [ELementType.HEATMAP]: HEATMAP,
    [ELementType.GLTF]: GLTF,
    [ELementType.Background]: Background,
    [ELementType.Dom3d]: Dom3d,
    [ELementType.HEATMAPS]: HEATMAPS,
    [ELementType.DomNew]: DomNew,
    [ELementType.Person]: Person,
    [ELementType.Roi3d]: Roi3d,
    [ELementType.HEATMAPCOMPLEX]: HEATMAPCOMPLEX,
    [ELementType.Ellipse]: Ellipse,
    [ELementType.Ellipse3d]: Ellipse3d,
    [ELementType.Car2D]: Car2d,
    [ELementType.Car3D]: Car3d,
    [ELementType.Car3DS]: Car3dS,
    [ELementType.Parking3d]: Parking3d,
    [ELementType.Parking]: Parking,
    [ELementType.Persons]: Persons,
    [ELementType.Person2d]: Person2d,
    // [ELementType.Fence]: Fence,
    [ELementType.Fence]: Roi3d,
};
export default Objects;
